import React from 'react';
import { Box } from '@mui/material';

const NetworkBackground = () => {
  return (
    <>
      {/* Hero Section Background */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '100vh',
          zIndex: -1,
          background: `
            linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)),
            url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />

      {/* Features Section Background */}
      <Box
        sx={{
          position: 'fixed',
          top: '100vh',
          left: 0,
          right: 0,
          height: '100vh',
          zIndex: -1,
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url('https://images.unsplash.com/photo-1588508065123-287b28e013da?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />

      {/* Coverage Section Background */}
      <Box
        sx={{
          position: 'fixed',
          top: '200vh',
          left: 0,
          right: 0,
          height: '100vh',
          zIndex: -1,
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url('https://images.unsplash.com/photo-1581362072978-14998d01fdaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />

      {/* Contact Section Background */}
      <Box
        sx={{
          position: 'fixed',
          top: '300vh',
          left: 0,
          right: 0,
          height: '100vh',
          zIndex: -1,
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
            url('https://images.unsplash.com/photo-1534423861386-85a16f5d13fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      />

      {/* Overlay for smooth transitions */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          background: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.4))',
          pointerEvents: 'none',
        }}
      />
    </>
  );
};

export default NetworkBackground;
